export default __webpack_public_path__ + "static/smu_2-d6a27325b9fa95ebaaec233685886a0e.jpg";